module.exports = "/dist/0aa3469593ade6c6bf6ad7717606eef6.png";